import { EngagementProvider } from './../Engagement/Engagement';
import { Media } from './../../Utilities/Media';

export interface ICoupon
{
	Type: string;
	CouponCode?: string;
	MobileCreativeID: string;
	DesktopCreativeID: string;
	SignUpSource: string;
	ButtonSelector: string;
}

export class BaseCouponsAndDiscounts
{
	public SiteCoupons: Array<ICoupon> = [];

	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
		this.ConfigurePage();
	}

	public ConfigurePage = (): void =>
	{
		if (this.SiteCoupons.length > 0)
		{
			this.SiteCoupons.forEach((coupon, index) =>
			{
				const button: HTMLButtonElement = document.querySelector(coupon.ButtonSelector);

				if (button instanceof HTMLElement)
				{
					button.setAttribute("data-coupon-id", index.toString());
					button.addEventListener("click", this.DisplayOffer);
				}
			});
		}
	};

	public DisplayOffer = (event: Event): void =>
	{
		event.preventDefault();

		let coupon: ICoupon;
		let creativeID: string;
		const offerButton = event.target;
		let offerID: number;
		const engagementProvider = new EngagementProvider();

		if (offerButton instanceof HTMLElement)
		{
			offerID = parseInt(offerButton.getAttribute("data-coupon-id"));
		}

		if (typeof this.SiteCoupons !== "undefined")
		{
			coupon = this.SiteCoupons[offerID];
			const mobileCreativeID = coupon.MobileCreativeID;
			const desktopCreativeID = coupon.DesktopCreativeID;

			if (Media.IsMobile && mobileCreativeID !== "")
			{
				creativeID = mobileCreativeID;
			}
			else if (Media.IsDesktop && desktopCreativeID !== "")
			{
				creativeID = desktopCreativeID;
			}
		}

		if (creativeID !== "")
		{
			engagementProvider.DisplaySignup(creativeID);
		}
	};
}